export const SEARCH_BY_VIN_BUTTON_CLICKED = "Search by VIN button clicked"
export const FIND_VEHICLE_BY_LICENSE_PLATE_FORM_SUBMITTED = "Search by License Plate form submitted"
export const USER_CONFIRMED_VEHICLE_FOR_BENEFITS_LOOKUP = "User Confirmed a vehicle for benefits lookup"
export const LICENSE_PLATE_INPUT_CONTINUE_BUTTON_CLICKED = "Button clicked: Opens License Plate Confirmation Model"
